import React from 'react';
import {WidgetProps, useEnvironment} from '@wix/yoshi-flow-editor';
import {IControllerProps} from '../../types/app.types';
import {GeneralError} from './GeneralError/GeneralError';
import {ControllerContext} from '../../domain/controllers/ControllerContext';
import {TPAComponentsProvider} from '@wix/wix-ui-tpa/cssVars';

type CartWidgetRootProps = {
  controllerProps: WidgetProps<IControllerProps>;
  children: React.ReactNode;
};

export const CartWidgetRoot = ({controllerProps, children}: CartWidgetRootProps) => {
  const {isRTL} = useEnvironment();

  if (controllerProps.generalError) {
    return <GeneralError />;
  }

  return (
    <ControllerContext value={controllerProps}>
      <TPAComponentsProvider value={{rtl: isRTL}}>{children}</TPAComponentsProvider>
    </ControllerContext>
  );
};
